import axios from 'src/api/Api';
import {
    VIEW_REPORT_PDF_SUCCESS,
    VIEW_REPORT_PDF_FAILURE,
} from 'src/pages/orders/redux/actions';
import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { convertObjectToQueryParams } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* viewPdfReport(action) {
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/reports/usageReports/pdf?`;

    const params = convertObjectToQueryParams(
        {
            myCASERef: action.payload.myCaseRef,
            pricing: action.payload.pricing,
            reportType: action.payload.reportOption,
        },
        true
    );
    let finalUrl = url + `${params}`;
    try {
        const result = yield axios
            .get(finalUrl)
            .then((response) => response.data);
        yield put({ type: VIEW_REPORT_PDF_SUCCESS, payload: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: finalUrl,
            requestPayload: action.payload
        });
        yield put({
            type: VIEW_REPORT_PDF_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
